import Utente from "./Utente";

export default Utente;
